/**
 * Created by rickborst on 26/07/2017.
 */

import {
    ActionTypes,
    SettingStates
} from '../../actions/pages/settings';

import { ActionTypes as DeviceActionTypes } from '../../actions/device';

const defaultState = {
        status: SettingStates.INITIAL,
        sections: {}
    },

    /**
     * Sets the settings sections in case of the corresponding action.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setSettingsState = function (state, action) {

        return {
            ...state,
            status: action.state
        };
    },

    /**
     * Changes device status to 'REMOVING'.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} State.
     */
    setRemoveDeviceLoader = function  (state, action) {
        let updatedDevices = state.sections.devices.map(item => {
            if (item.udid === action.device.udid) {
                return {
                    ...item,
                    apiSpecifics: {
                        ...item.apiSpecifics,
                        status: 'REMOVING'
                    }
                };
            }

            return item;
        });

        return {
            ...state,
            sections: {
                ...state.sections,
                devices: updatedDevices
            }
        };
    },

    /**
     * Sets the settings sections in case of the corresponding action.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    setSettingsSections = function (state, action) {

        return {
            ...state,
            sections: action.sections
        };
    },

    /**
     * Returns the settings state.
     *
     * @param {Object} state - Current state.
     * @param {Object} action - Action object.
     * @returns {Object} Current/new state.
     */
    settings = function (state = defaultState, action) {

        switch (action.type) {

            case ActionTypes.SET_SETTINGS_STATE:
                return (state = setSettingsState(state, action));

            case ActionTypes.SET_SETTINGS_SECTIONS:
                return (state = setSettingsSections(state, action));

            case DeviceActionTypes.ATTEMPT_TO_REMOVE_DEVICE:
                return setRemoveDeviceLoader(state, action);

            default:
                return state;
        }
    };

export default settings;



// WEBPACK FOOTER //
// ./src/js/store/reducers/pages/settings.js